import React from 'react';
import { Button } from './ui/button';
import { MessageCircle } from 'lucide-react';
import { mediaHighlight } from '../data/mockData';
import { useFormModal } from './FormModalContext';

export const MediaSection = () => {
  const { openForm } = useFormModal();
  return (
    <section id="media" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Title */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-50 rounded-full border border-red-200 mb-4">
              <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
              <span className="text-sm font-medium text-red-700">DESTAQUE NA MÍDIA</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              {mediaHighlight.title}
            </h2>
            <p className="text-xl text-gray-600">
              {mediaHighlight.subtitle}
            </p>
            <div className="w-20 h-1 bg-gradient-to-r from-[#eb068c] to-[#c7056f] mx-auto rounded-full mt-6"></div>
          </div>

          {/* Video Section */}
          <div className="grid md:grid-cols-2 gap-8 items-center">
            {/* Video Player Embedded */}
            <div className="relative group rounded-2xl overflow-hidden shadow-2xl">
              <div className="relative aspect-video">
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/MX8NqDMogqA"
                  title="Plantinha de Geladeira no Programa Mais Você"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-full"
                ></iframe>
              </div>
              {/* TV Logo Badge */}
              <div className="absolute top-4 left-4 bg-red-600 text-white px-4 py-2 rounded-lg font-bold text-sm shadow-lg z-10">
                📺 GLOBO
              </div>
            </div>

            {/* Content */}
            <div className="space-y-6">
              <div className="bg-gradient-to-br from-pink-50 to-fuchsia-50 rounded-2xl p-8 border border-pink-200">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  Na Geladeira Mais Famosa do Brasil! 🌟
                </h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  {mediaHighlight.description}
                </p>
              </div>

              {/* Highlights */}
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-white rounded-xl p-6 shadow-md border border-pink-100">
                  <div className="text-3xl font-bold text-[#eb068c] mb-1">1M+</div>
                  <p className="text-gray-600 text-sm">Visualizações</p>
                </div>
                <div className="bg-white rounded-xl p-6 shadow-md border border-pink-100">
                  <div className="text-3xl font-bold text-[#eb068c] mb-1">Nacional</div>
                  <p className="text-gray-600 text-sm">Cobertura</p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Button Below Video */}
          <div className="mt-12 text-center">
            <Button 
              size="lg"
              onClick={openForm}
              className="bg-[#20BA5A] hover:bg-[#178C41] text-white px-10 py-7 text-xl rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
            >
              <MessageCircle className="mr-3 h-6 w-6" />
              Solicitar Orçamento
            </Button>
          </div>

          {/* Bottom CTA */}
          <div className="mt-16 bg-gradient-to-r from-[#eb068c] to-[#c7056f] rounded-2xl p-8 md:p-10 text-white text-center shadow-xl">
            <h3 className="text-2xl md:text-3xl font-bold mb-6">
              O seu próximo presente pode ser inesquecível.
            </h3>
            <Button 
              size="lg"
              onClick={openForm}
              className="bg-white text-[#eb068c] hover:bg-gray-100 px-8 py-6 text-lg rounded-xl shadow-lg hover:shadow-xl transition-all duration-300"
            >
              Fazer o meu pedido
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
